import { render } from "./VideoFrame.vue?vue&type=template&id=58ac4995&scoped=true"
import script from "./VideoFrame.vue?vue&type=script&lang=js"
export * from "./VideoFrame.vue?vue&type=script&lang=js"

import "./VideoFrame.vue?vue&type=style&index=0&id=58ac4995&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ac4995"]])

export default __exports__